Bingo.ModalTransplantation = {};

Bingo.ModalTransplantation.init = function () {
    $('.modal.transplant').on('show.bs.modal', function () {
        const el = $(this).detach();
        el.appendTo($('body'));
    });
};
